<template>
  <Header>
    <Menu mode="horizontal" theme="dark" active-name="1">
      <div class="layout-logo">后台管理系统</div>
      <Icon
        @click.native="collapsedSider"
        :class="rotateIcon"
        style="margin: 0 20px; color: #fff"
        type="md-menu"
        size="24"
      ></Icon>
      <div class="header-right">
        <NotificationBell />
        <Dropdown class="log_out" @on-click="downMenuClick">
          <Icon type="md-contact" size="30" />
          <DropdownMenu slot="list">
            <DropdownItem name="updatePs">修改密码</DropdownItem>
            <DropdownItem name="logOut">退出登录</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </Menu>
  </Header>
</template>

<script>
import NotificationBell from './NotificationBell.vue'

export default {
  name: 'hl-Header',
  components: {
    NotificationBell
  },
  props: ['isCollapsed'],
  data() {
    return {}
  },
  computed: {
    rotateIcon() {
      return ['menu-icon', this.isCollapsed ? 'rotate-icon' : '']
    },
  },
  methods: {
    collapsedSider() {
      this.$emit('collapsedSider')
    },
    downMenuClick(val) {
      this.$emit('downMenuClick', val)
    },
  },
}
</script>

<style scoped>
.header-right {
  float: right;
  display: flex;
  align-items: center;
  height: 100%;
  padding-right: 20px;
}

.header-right > * {
  margin-left: 20px;
  color: #fff;
}
</style>
